<template>
  <div class="ac1">
    <div class="banner">
      <img src="/imgs/b3.jpg" alt="" />
    </div>
    <div class="container">
      <!-- 标题 -->
      <div class="at-title">
        <h4>Charging information</h4>
        <h2>收费资讯</h2>
      </div>

      <!-- 循环项 -->
      <div
        class="at-item"
        v-for="(item, index) in this.myData"
        :key="index"
        @click="gopay(item.id)"
      >
        <div class="item-l">
          <img :src="item.img" alt="" />
        </div>
        <!-- 右侧信息 -->
        <div class="item-r">
          <!-- 标题 -->
          <div class="item-title">{{ item.title }}</div>
          <!-- 文本 -->
          <p>
            {{ item.jj }}
          </p>
          <!-- 信息层 -->
          <div class="item-info">
            <span>来源：{{item.author}}</span>
            <span>收费阅读：2元/篇</span>
          </div>
        </div>
      </div>
    </div>
    <modal
      title="请付款阅读"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img src="/imgs/pay.png" />
        <h2>微信支付：2元</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal.vue";
export default {
  name: "ac1",
  components: {
    Modal,
  },
  data() {
    return {
      href: "index.html",
      ac1: [],
      ac2: [],
      ac3: [],
      ac: [],
      myData: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init1();
    document.title = "北京航笛互联网技术有限公司";
  },
  methods: {
    init1() {
      this.axios.get("/mock/index2.json").then((res) => {
        const data = res.data;
        // 咨询区块1
        this.myData = data.splice(0,6);
      });
    },
    // 跳转功能
    goDays(methodsWords, id) {
      this[methodsWords](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      // console.log('1')
      // alert("资讯每篇2元，点击确定购买");
      // this.showModal = true;

      if (this.state == 0) {
        // this.$router.push("/pay");
        this.showModal = true;
        console.log(this.showModal);
      }
      // 未登录
      if (this.state !== 0) {
        alert("资讯每条2元，点击确定登录购买");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    msub() {
      // alert("支付失败！");
      this.$message.error("支付失败!");
      this.showModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac1 {
  margin-top: 65px;
  .banner {
    width: 100%;
    height: 300px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .container {
    // width: 980px;
    //   标题
    .at-title {
      border-bottom: 2px dashed #ccc;
      width: 100%;
      margin: 30px 0;
      h4 {
        font-size: 18px;
        color: $colorZ;
      }
      h2 {
        font-size: 28px;
        font-weight: 400;
        margin-bottom: 15px;
      }
    }
    //   循环项
    .at-item {
      width: 100%;
      height: 200px;
      @include flex();
      box-sizing: border-box;
      transition: all 0.3s;
      margin: 28px auto;
      border-bottom: 1px dashed #ccc;
      &:hover {
        background: #eee;
      }
      .item-l {
        width: 500px;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      // 右侧
      .item-r {
        width: 90%;
        height: 100%;
        //   background-color: #ff6600;
        padding: 20px;
        box-sizing: border-box;
        // margin-left: 30px;
        text-align: left;
        //   标题
        .item-title {
          font-size: 16px;
          font-weight: bold;
          margin: 10px 0;
          transition: all 0.3s;
          color: #555;
        }
        //   文本
        p {
          font-size: 14px;
          // text-indent: 30px;
          color: #7c7c7c;
          line-height: 25px;
          margin: 15px auto;
          text-align: left;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
        //   信息层
        .item-info {
          width: 100%;
          height: 40px;
          // @include flex();
          display: flex;
          align-items: center;
          span {
            font-size: 13px;
            color: #666;
            margin-right: 10px;
        
          }
        }
      }
    }
  }
}
</style>
